import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import { getFrozenEntityId } from 'containers/FrozenAction/selectors';
import { deleteCarouselElement } from 'containers/Layouts/actions';
import styles from './styles.module.scss';

type Props = {
  carouselId: string;
  sectionId: string;
  isReadOnly: boolean;
  slideIds: string[];
  children: React.ReactElement;
  dataTestId?: string;
};

const CarouselActions: React.FC<Props> = ({
  carouselId,
  sectionId,
  isReadOnly,
  slideIds,
  children,
  dataTestId = 'carousel-actions',
}) => {
  const dispatch = useDispatch();
  const frozenEntityId = useSelector(getFrozenEntityId);

  const isInsideSlideEditView = frozenEntityId !== null && slideIds.includes(frozenEntityId);
  const showDeleteButton = !isReadOnly && !isInsideSlideEditView;

  const handleDelete = (): void => {
    dispatch(deleteCarouselElement(carouselId, sectionId));
  };

  return (
    <AccessibleDiv
      className={styles.CarouselActions}
      data-testid={dataTestId}
    >
      {React.cloneElement(children, {
        onDelete: showDeleteButton ? handleDelete : undefined,
      })}
    </AccessibleDiv>
  );
};

export default CarouselActions;
